export default __webpack_public_path__ + "static/media/summit.cdf52ae4.jpg";